// extracted by mini-css-extract-plugin
export default {"root":"tile-module--root--e35fb","image":"tile-module--image--44845","title":"tile-module--title--4b498","arrow":"tile-module--arrow--24fe6"};